import { compose, identity } from 'ramda';
import React from 'react';
import PropTypes from 'prop-types';
import {
  BrowserRouter, Routes, Route, Navigate,
} from 'react-router-dom';
import { withTwnelContext, IS_IFRAME } from '@twnel/web-components';
import { logTime } from 'src/data/util';
import GlobalStyle from 'src/ui/util/GlobalStyle';
import withRouteMatch from 'src/ui/util/withRouteMatch';
import { withIframeToggle, withEventReporter } from 'src/ui/widget';

const enhancer = compose(
  withTwnelContext,
  IS_IFRAME ? withIframeToggle : withEventReporter,
);

const onMount = IS_IFRAME ? identity : () => {
  const { performance } = window || {};
  if (performance) {
    const timeSincePageLoad = performance.now();
    logTime('render', timeSincePageLoad);
  }
};

const App = ({ Body, defaultCompany }) => {
  React.useEffect(onMount, []);
  const Page = React.useMemo(() => withRouteMatch(Body), [Body]);
  return (
    <BrowserRouter>
      <GlobalStyle />
      <Routes>
        <Route path="/:id" element={<Page />} />
        <Route path="*" element={<Navigate to={`/${defaultCompany}`} replace />} />
      </Routes>
    </BrowserRouter>
  );
};

App.propTypes = {
  Body: PropTypes.elementType.isRequired,
  defaultCompany: PropTypes.string.isRequired,
};

export default enhancer(App);
